import sleep from 'sleep-promise';
import API from './api';
import RefAPI from './reference-api';
import RawSequenceData from '../../../../models/raw-sequence-data';


export default async function loadFromLocalDB(rawDataCollection) {

  await sleep(0);
  const data = await API({
    accessions: rawDataCollection.accessions
  });
  const {viewer: {sequences}} = data;
  if (typeof sequences === 'undefined') {
    return rawDataCollection;
  }

  const existingGenes = {};
  const _accessionToPatients = {};
  // const existingPatients = {};
  if (!sequences) {
    return rawDataCollection;
  }
  for (const {
    node: {
      accession,
      isolate: {
        isolateName, isolateDate, dateMatch, isolateType,
        host, species, gene, authorSubtype,
        clinicalIsolate,
        patient: {id: existingPatientId, pseudoName: ptAlias, region, isChild}
      }
    }
  } of sequences.edges) {
    existingGenes[accession] = existingGenes[accession] || new Set();
    existingGenes[accession].add(gene);
    _accessionToPatients[accession] = {
      existingPatientId, ptAlias, region,
      isolateName, isolateDate, dateMatch,
      isolateType, host, species, authorSubtype,
      isChild: isChild ? 'Yes' : 'No'
    };
    if (clinicalIsolate) {
      const {source, culture, seqTemplate, cloneMethod, seqMethod} = clinicalIsolate;
      Object.assign(_accessionToPatients[accession], {
        source, culture, seqTemplate, cloneMethod, seqMethod
      });
    }
  }
  const {rawSequences} = rawDataCollection;
  for (const seq of rawSequences) {
    const {accession} = seq;
    seq.existingGenes = Array.from(
      existingGenes[accession] || []).join(',');

    // const {ptAlias: origPtAlias} = seq;
    // if (accession in _accessionToPatients) {
    //   const {
    //     existingPatientId, ptAlias,
    //     region, host, isChild, dateMatch
    //   } = _accessionToPatients[accession];

    //   existingPatients[origPtAlias] = {
    //     existingPatientId, ptAlias, region, host,
    //     isChild, isolateDateMatch: dateMatch
    //   };

    // }
  }
  for (const seq of rawSequences) {
    const {existingPatientId, accession,
      // ptAlias
    } = seq;
    if (existingPatientId) {
      continue;
    }
    // Object.assign(
    //   seq,
    //   existingPatients[ptAlias] || {},
    //   _accessionToPatients[accession] || {}
    // );
    Object.assign(
      seq,
      _accessionToPatients[accession] || {}
    );
  }
  // LU tables should be updated after sequences were loaded
  rawDataCollection = await updateLUTables(rawDataCollection);

  return rawDataCollection;
}

export async function updateLUTables(rawDataCollection) {
  await sleep(0);
  const data = await API({
    regions: rawDataCollection.regions,
    sources: rawDataCollection.sources
  });
  const {viewer: {luCountries, luBodySources}} = data;
  if (typeof luCountries !== 'undefined') {
    rawDataCollection.validCountries = luCountries.edges.map(({node: {region}}) => region);
  }
  if (typeof luBodySources !== 'undefined') {
    rawDataCollection.validBodySources = luBodySources.edges.map(({node: {source}}) => source);
  }

  return rawDataCollection;
}


export async function handleLoadSeqFromHIVDB(rawDataCollection) {
  // if (rawDataCollection.hasRawSequences) {
  //   return;
  // }
  const {reference} = rawDataCollection;
  if (reference.loadFrom !== 'HIVDB') {
    return;
  }

  const response = await RefAPI(reference.id);
  let references = response.references.edges.map(({node}) => node);

  if (references.length === 0) {
    return;
  }
  const isolateObjs = references[0].isolateObjs;

  let rawSequences = [];
  let rawAlignments = [];
  let sequenceType = 'complete';
  let seqType = 'ClinicalList';
  for (const isolateObj of isolateObjs) {
    const sequences = isolateObj.sequences.edges.map(({node}) => node) || [];
    let clinicalIsolate = {};
    let labIsolate = {};

    for (const seq of sequences) {
      if (seq.sequenceType === 'Consensus') {
        continue;
      }

      let rawSeq = {
        ptAlias: isolateObj.patient.pseudoName || '',
        seqType: seq.sequenceType,
        existingPatientId: isolateObj.patientId,
        refName: reference.refName,
        accession: seq.accession || '',
        existingGenes: isolateObj.gene,
        isolateName: isolateObj.isolateName,
        isolateDate: isolateObj.isolateDate,
        isolateDateMatch: isolateObj.dateMatch,
        isolateType: isolateObj.isolateType,
        species: isolateObj.species,
        host: isolateObj.host,
        region: isolateObj.patient.region,
        sequence: seq.aaseq,
        isChild: isolateObj.patient.isChild || 'No',
        hivdbDRMs: seq.drms,
      };

      if (isolateObj.isolateType === 'Clinical') {
        clinicalIsolate = isolateObj.clinicalIsolate;
        rawSeq.cloneMethod = clinicalIsolate.cloneMethod || 'None';
        rawSeq.cloneName = seq.cloneName || '$$AUTO$$';
        rawSeq.source = clinicalIsolate.source;
        rawSeq.culture = clinicalIsolate.culture;

        if (seq.sequenceType === 'IncompleteSequence') {
          rawSeq.gene = isolateObj.gene;
          rawSeq.mutations = seq.mutationList;
          rawSeq.parent = 'HXB2';
          sequenceType = 'incomplete';
        } else if (seq.sequenceType === 'PartialMutationList') {
          rawSeq.gene = isolateObj.gene;
          rawSeq.mutations = seq.mutationList;
          rawSeq.parent = 'HXB2';
          sequenceType = 'incomplete';
        }
      } else {
        labIsolate = isolateObj.labIsolate;
        rawSeq.mutations = labIsolate.mutationList;
        rawSeq.parent = labIsolate.parent;
        rawSeq.gene = isolateObj.gene;
        rawSeq.labSdm = labIsolate.sdm;
        rawSeq.labPassage = labIsolate.passage;
        sequenceType = 'incomplete';
        seqType = 'LabList';
      }

      rawSeq = new RawSequenceData(rawSeq);
      rawSequences.push(rawSeq);

      if (sequenceType === 'complete') {
        let rawGeneAlign = {
          firstAA: seq.firstAa,
          lastAA: seq.lastAa,
          gene: isolateObj.gene,
          alignedAAs: seq.aaseq,
          alignedNAs: seq.naseq,
          mutations: [],
        };
        let rawAlign = {
          rawSequenceUuid: rawSeq.uuid,
          subtype: isolateObj.subtype,
          species: isolateObj.species,
          validationResults: [],
          geneSequences: [rawGeneAlign],
        };
        rawAlignments.push(rawAlign);

      }
    }
  }

  rawDataCollection.rawSequences = rawSequences;
  rawDataCollection.rawAlignments = rawAlignments;
  rawDataCollection.sequenceType = sequenceType;
  rawDataCollection.seqType = seqType;
}



// WEBPACK FOOTER //
// ./src/views/wizard/isolate/hivdb/load-db.js